import React from "react";

import MySitePublic from "./components/MySitePublic";
import MySiteDesign from "./components/MySiteDesign";
import MySiteState from "./components/MySiteState";
import MySiteText from "./components/MySiteText";
import MySiteWorks from "./components/MySiteWorks";
import MySiteReviews from "./components/MySiteReviews";
import MySiteFooter from "./components/MySiteFooter";

// NOTE: コミッション登録（MySiteService）はメニューから一旦除外（後日実装）。
// お問い合わせ（MySiteContact）はページごと廃止。
const rightColumnComponents = {
  mySitePublic: <MySitePublic />,
  mySiteDesign: <MySiteDesign />,
  mySiteState: <MySiteState />,
  mySiteText: <MySiteText />,
  mySiteWorks: <MySiteWorks />,
  mySiteReviews: <MySiteReviews />,
  mySiteFooter: <MySiteFooter />,
};

export default rightColumnComponents;
